import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";

export default function DiscardChangesDialog({
  open,
  onClose,
  onConfirm,
}: {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}) {
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-200"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-150"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/40 backdrop-blur-sm" />
        </Transition.Child>

        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-200"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-150"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <Dialog.Panel className="w-full max-w-sm rounded-2xl bg-dark-background-secondary p-6 text-white shadow-xl">
              <Dialog.Title className="text-lg font-semibold">
                Discard all changes?
              </Dialog.Title>
              <Dialog.Description className="text-sm text-dark-text mt-1">
                Are you sure you want to discard all the changes?
              </Dialog.Description>

              <div className="mt-6 flex justify-end gap-3">
                <button
                  type="button"
                  className="rounded-lg bg-dark-background-secondary-medium px-4 py-2 text-sm text-dark-text hover:bg-dark-background-secondary border border-dark-border"
                  onClick={onClose}
                >
                  No, go back
                </button>
                <button
                  type="button"
                  className="rounded-lg bg-brand-600 px-4 py-2 text-sm font-medium text-white hover:bg-brand-500"
                  onClick={onConfirm}
                >
                  Yes, discard
                </button>
              </div>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
